import { render } from '@wordpress/element';
import App from './components/App';
import './style.css';

const rootElement = document.getElementById('instant-page-load-setting');
if (rootElement) {
    render(<App />, rootElement);
}
